import { render, staticRenderFns } from "./BoxContent7.vue?vue&type=template&id=28e3c452&scoped=true"
import script from "./BoxContent7.vue?vue&type=script&lang=js"
export * from "./BoxContent7.vue?vue&type=script&lang=js"
import style0 from "./BoxContent7.vue?vue&type=style&index=0&id=28e3c452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3c452",
  null
  
)

export default component.exports